import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div>
       <footer className="footer-section">
            <div className="upper-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="widget about-widget">
                                   <Link to='/'> <img src="assets/images/logo.png" style={{width:"450px"}} alt="logo"/> </Link>
                               
                                <p>We work with a passion of taking challenges and creating new ones in Semicon & Embedded sectors</p>
                                
                            </div>
                        </div>
                        <div className="col col-xl-6 col-lg-2 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Follow Us</h3>
                                </div>
                                <div className="widget social-widget p-0">
                                    <ul>
                                        <li><Link to="#" style={{marginTop:"5px"}}><i className="ti-facebook" ></i></Link></li>
                                        <li><Link to="#"><i className="ti-pinterest"></i></Link></li>
                                        <li><Link to="#"><i className="ti-twitter-alt"></i></Link></li>
                                        <li><Link to="#"><i className="ti-instagram"></i></Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        
                        {/* <div class="col col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                            <div class="widget instagram">
                                <div class="widget-title">
                                    <h3>Our Gallery</h3>
                                </div>
                                <ul>
                                    <li><a href="project-single.html"><img src="assets/images/gallery/img-1.jpg" /></a></li>
                                    <li><a href="project-single.html"><img src="assets/images/gallery/img-2.jpg" /></a></li>
                                    <li><a href="project-single.html"><img src="assets/images/gallery/img-3.jpg" /></a></li>
                                    <li><a href="project-single.html"><img src="assets/images/gallery/img-4.jpg" /></a></li>
                                    <li><a href="project-single.html"><img src="assets/images/gallery/img-5.jpg" /></a></li>
                                    <li><a href="project-single.html"><img src="assets/images/gallery/img-6.jpg" alt=""/></a></li>
                                </ul>
                            </div>
                        </div> */}
                    </div>
                </div>
                 {/* <!-- end container --> */}
            </div>
            <div className="lower-footer">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col col-lg-6 col-12">
                            <div className="copy-right">
                                <p className="copyright"> &copy; 2024 <Link to="/">ROUTE2SOC TECHNOLOGIES</Link>, All
                                    Rights
                                    Reserved.</p>
                            </div>
                        </div>
                        <div className="col col-lg-6 col-12">
                            <ul className="lower-footer-link">
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="/about">About Us</Link></li>
                                <li><Link to="/semiconservices">Semicon Services</Link></li>
                                <li><Link to="/embededservices">Embedded Services</Link></li>
                                <li><Link to="/contacts">Contact Us</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
  );
}

export default Footer;
